import { BetTypeGroup } from '@/interface/enum';

export function isNewBetType(betTypeGroupId: number) {
    return betTypeGroupId !== 0;
}

export function isMainMarket(betTypeGroupId: number) {
    return betTypeGroupId === 0;
}

const nextGoalMarketGroups = [
    BetTypeGroup.Soccer_FirstGoal,
    BetTypeGroup.Soccer_SecondGoal,
    BetTypeGroup.Soccer_ThirdGoal,
    BetTypeGroup.Soccer_ForthGoal,
    BetTypeGroup.Soccer_FifthGoal,
    BetTypeGroup.Soccer_SixthGoal,
    BetTypeGroup.Soccer_SeventhGoal,
    BetTypeGroup.Soccer_EighthGoal,
    BetTypeGroup.Soccer_NinthGoal,
    BetTypeGroup.Soccer_TenthGoal,
];

export function isNextGoal(betTypeGroupId: number): boolean {
    return nextGoalMarketGroups.includes(betTypeGroupId);
}
